'use client';

import { c as _c } from "react/compiler-runtime";
import { SpaceMemberRoles, Types } from '@shared/all/domains/spaces';
import toast from '@shared/utils/helpers/toast';
import useSpace from '@shared/utils/hooks/useSpace';
import useUser from '@shared/utils/hooks/useUser';
import { Mail } from 'lucide-react';
import { useState } from 'react';
import { useHeaderHeight } from '../../hooks/useHeaderHeight';
import { client, type RouterOutputs } from '../../utils/trpc';
type Props = {
  space: RouterOutputs['spaces']['get'];
};
const SpaceInviteBanner = t0 => {
  const $ = _c(21);
  const {
    space
  } = t0;
  const {
    currentUser
  } = useUser();
  const {
    joinSpaceUpdate
  } = useSpace();
  const [joining, setJoining] = useState(false);
  const headerClearance = useHeaderHeight();
  const isInvited = space.membership?.roles.includes(SpaceMemberRoles.INVITED) && !space.membership.roles.includes(SpaceMemberRoles.MEMBER);
  if (!currentUser.isAuthenticated || !isInvited) {
    return null;
  }
  const isPrivateSpace = space.types.includes(Types.PRIVATE);
  const audience = isPrivateSpace ? "the members of this space" : "everyone viewing this space";
  let t1;
  if ($[0] !== joinSpaceUpdate || $[1] !== space.spaceSlug) {
    t1 = async () => {
      setJoining(true);
      const [error, data] = await client.spaces.join.mutate({
        slug: space.spaceSlug
      });
      setJoining(false);
      if (error) {
        toast(error.message ?? "Failed to join space.", "", "error");
        return;
      }
      joinSpaceUpdate(space.spaceSlug, data);
    };
    $[0] = joinSpaceUpdate;
    $[1] = space.spaceSlug;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleAccept = t1;
  let t2;
  if ($[3] !== headerClearance) {
    t2 = {
      marginTop: headerClearance
    };
    $[3] = headerClearance;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Mail size={18} className="shrink-0 text-white" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== space.name) {
    t4 = <p className="truncate font-emphasis">You've been invited to {space.name}</p>;
    $[6] = space.name;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = currentUser.isPrivate ? `Your profile isn't visible right now. Once you accept, your presence and content in this space will become visible to ${audience}.` : `Accept to start posting in ${space.name}.`;
  let t6;
  if ($[8] !== t5) {
    t6 = <p className="text-xs text-white/80">{t5}</p>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <div className="min-w-0 flex-1 text-sm text-white">{t4}{t6}</div>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = joining ? "Joining\u2026" : "Accept";
  let t9;
  if ($[13] !== handleAccept || $[14] !== joining || $[15] !== t8) {
    t9 = <button onClick={handleAccept} disabled={joining} className="flex h-8 shrink-0 items-center rounded-lg bg-white px-3 text-xs font-semibold text-primary transition-colors hover:bg-white/90 disabled:opacity-60 sm:px-4 sm:text-sm">{t8}</button>;
    $[13] = handleAccept;
    $[14] = joining;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t2 || $[18] !== t7 || $[19] !== t9) {
    t10 = <div style={t2} className="relative z-20 flex items-center gap-3 bg-[rgba(var(--primary),0.6)] px-3 py-2 shadow-sm backdrop-blur-xl sm:gap-4 sm:px-4">{t3}{t7}{t9}</div>;
    $[17] = t2;
    $[18] = t7;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};
export default SpaceInviteBanner;